<template>
    <div class="basket">
        <div @click="toggleDropdown">
            <span class="count" v-if="count">{{ count }}</span>
            <i class="icon-shopping-cart"></i>
        </div>
        <header-basket-dropdown v-if="items.length && show"></header-basket-dropdown>
    </div>
</template>

<script>
/* global App */
import { createNamespacedHelpers } from 'vuex'
import HeaderBasketDropdown from './HeaderBasketDropdown.vue'

const { mapState, mapActions, mapGetters } = createNamespacedHelpers('cart')

export default {

  components: {
    HeaderBasketDropdown
  },

  data () {
    return {
      show: false
    }
  },

  computed: {
    ...mapState(['items']),
    ...mapGetters(['count'])
  },

  created () {
    this.requestItems()

    App.dispatcher.listen('basket.dropdown.close', () => {
      this.show = false
    })
  },

  methods: {
    ...mapActions(['requestItems']),

    toggleDropdown () {
      this.show = !this.show
    }
  }
}
</script>
